// 实操类别
export const practicalQuestions = [
  {
    value: 1,
    label: "图像分类",
    questions: [],
  },
  { value: 2, label: "图像标注", questions: [] },
  { value: 7, label: "图像分割", questions: [] },
  { value: 3, label: "视频识别", questions: [] },
  { value: 4, label: "音频识别", questions: [] },
  { value: 5, label: "时序检测", questions: [] },
  { value: 6, label: "简答题", questions: [] },
];
// 理论类别
export const theoryQuestions = [
  { value: 1, label: "单选题", questions: [] },
  { value: 2, label: "判断题", questions: [] },
  { value: 3, label: "多选题", questions: [] },
];

export const quesIndex = [
  "一",
  "二",
  "三",
  "四",
  "五",
  "六",
  "七",
  "八",
  "九",
  "十",
];
